import React from 'react'
import { mobile } from './tokens'

interface MobileQuickActionProps {
  label: string
  icon: React.ReactNode
  onClick?: () => void
  href?: string
  disabled?: boolean
  muted?: boolean
  className?: string
}

/** Circular icon + label used on job detail (Navigate / Job Chat / Note / Photo / Checklist). */
export function MobileQuickAction({
  label,
  icon,
  onClick,
  href,
  disabled,
  muted,
  className = '',
}: MobileQuickActionProps) {
  const circle = muted || disabled ? mobile.quickActionCircleMuted : mobile.quickActionCircle
  const inner = (
    <>
      <span className={circle}>{icon}</span>
      <span className={mobile.quickActionLabel}>{label}</span>
    </>
  )

  if (href && !disabled) {
    return (
      <a
        href={href}
        target={href.startsWith('tel:') ? undefined : '_blank'}
        rel={href.startsWith('tel:') ? undefined : 'noopener noreferrer'}
        className={`${mobile.quickAction} ${className}`.trim()}
      >
        {inner}
      </a>
    )
  }

  return (
    <button
      type="button"
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      aria-disabled={disabled || undefined}
      className={`${mobile.quickAction} ${className}`.trim()}
    >
      {inner}
    </button>
  )
}
